import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'projects/ProjetoBaseAngular/app/shared.module';
import { MetaMsgTemplateButtonComponent } from './msg-template-button/msg-template-button.component';
import { MetaMsgTemplateButtonModalComponent } from './msg-template-button/msg-template-button-modal/msg-template-button-modal.component';
import { MetaMsgTemplateComponentComponent } from './msg-template-component/msg-template-component.component';
import { MetaMsgTemplateComponentModalComponent } from './msg-template-component/msg-template-component-modal/msg-template-component-modal.component';
import { MetaMsgTemplateComponentParametroModalComponent } from './msg-template-component/msg-template-component-modal/parametro-modal/parametro-modal.component';
import { MetaMsgTemplateMetaListModalComponent } from './msg-template-list-modal/msg-template-list-modal.component';
import { MetaMsgTemplateModalComponent } from './msg-template-modal/msg-template-modal.component';
import { MetaMsgTemplateComponent } from './meta-msg-template.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    MetaMsgTemplateComponent,
    MetaMsgTemplateModalComponent,
    MetaMsgTemplateComponentComponent,
    MetaMsgTemplateComponentModalComponent,
    MetaMsgTemplateComponentParametroModalComponent,
    MetaMsgTemplateMetaListModalComponent,
    MetaMsgTemplateButtonComponent,
    MetaMsgTemplateButtonModalComponent
  ]
})
export class MetaMsgTemplateModule { }
